// A user is an Albacross admin when their `type` column is 2 (the raw API exposes `type`, not a boolean).
export const ALBACROSS_ADMIN_TYPE = 2

export const isAlbacrossAdmin = (user: any) => user?.type === ALBACROSS_ADMIN_TYPE

// The edit form works on the raw (snake_case) user; only editable fields are sent. `admin` is a boolean the API accepts (maps to `type` server-side).
export const userToServer = (x: any) => ({
  first_name: x.first_name,
  last_name: x.last_name,
  email: x.email,
  admin: x.admin,
})
